import { css, CSSResult } from 'lit';
import { fontAwesomeStyles } from './fontAwesomeStyles.ts';

export const commonStyles: (CSSResult | CSSStyleSheet)[] = [
  fontAwesomeStyles,
  css`
    :host {
      --blue-1: #184664;
      --blue-2: #266FA0;
      --blue-3: #3498DB;
      --blue-4: #62B6ED;
      --blue-5: #9CD1F4;
      --blue-6: #D8ECFA;
      --blue-7: #EAF5FD;

      --neutral-1: #1E252A;
      --neutral-2: #313C43;
      --neutral-3: #42525C;
      --neutral-4: #6B8393;
      --neutral-5: #A2B2BC;
      --neutral-6: #DAE0E4;
      --neutral-7: #ECF0F2;
      --neutral-8: #F6F8F9;
      --neutral-9: #F9FAFB;
      --neutral-10: #FFFFFF;

      --green-1: #12502C;
      --green-2: #1D7F46;
      --green-3: #27AE60;
      --green-4: #61C48B;
      --green-5: #9CDAB6;
      --green-6: #D7F0E2;
      --green-7: #EBF7F0;

      --orange-1: #522900;
      --orange-2: #a54700;
      --orange-3: #FF9900;
      --orange-4: #FFBB00;
      --orange-5: #FFCC33;
      --orange-6: #FFDD66;
      --orange-7: #FFEE99;

      --primary-1: var(--blue-1);
      --primary-2: var(--blue-2);
      --primary-3: var(--blue-3);
      --primary-4: var(--blue-4);
      --primary-5: var(--blue-5);
      --primary-6: var(--blue-6);
      --primary-7: var(--blue-7);

      --primary-color: var(--primary-3);
      --secondary-color: var(--neutral-4);
      --side-background: var(--neutral-8);
      --side-border: var(--neutral-6);
      --hover-color: var(--neutral-7);
      --good-color: var(--green-3);
      --bad-color: #F00;
      --light-color: #FFF;
      --dark-color: var(--neutral-3);
      --darker-color: var(--neutral-1);
      --selected-color: var(--primary-color);
      --button-hover-color: var(--blue-2);
    }
    
    :host * {
      box-sizing: border-box;
    }

    button {
      font-size: 15px;
      font-weight: 400;
      padding: 12px 24px;
      transition: all .25s;
    }

    button:focus {
      outline: none;
    }

    section {
      margin: 0 16px 24px 0;
      box-shadow: 0 4px 6px var(--neutral-6);
      border-radius: 5px;
      display: inline-block;
      min-width: 100%;
    }

    section header h4,
    section,
    section > table,
    section > table > thead {
      background: var(--light-color);
    }

    section > table > thead {
      background: var(--neutral-8);
    }

    input.filter,
    select.filter {
      background-image: url("../../../images/filled-filter-icon_gray.svg");
      background-repeat: no-repeat;
      background-size: 1.6em;
      background-position: 5px center;
      padding-left: 29px !important;
    }

    input.filter.filter-smaller,
    select.filter.filter-smaller {
      background-size: 1.2em;
      padding-left: 25px !important;
    }

    .four-oh {
      width: 60%;
      text-align: center;
      padding: 32px 32px 48px;
      font-size: 1.1rem;
      margin: 72px auto auto;
      color: var(--neutral-2);
      max-width: 720px;
      background: white;
    }

    .four-oh.modal {
      padding: 48px 32px 48px;
      background: var(--neutral-8);
      border-radius: 5px;
      border: var(--neutral-7);
      box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
    }

    .four-oh.modal a {
      color: #3498DB;
      text-decoration: none;
      cursor: pointer;
    }

    .four-oh i {
      margin-top: 16px;
      color: var(--blue-3);
    }

    #refresh-area {
      flex: 0 0 250px;
      display: flex;
      align-items: center;
    }
    
    #refresh-area weekly-icon {
      color: var(--primary-color);
      margin: 2px 8px 0 0;
      font-size: 17px;
      text-align: right;
    }

    #refresh-area ul {
      white-space: nowrap;
      padding: 0;
      list-style: none;
      margin: 0;
      text-align: right;
    }
    
    #refresh-area weekly-icon {
      cursor: pointer;
    }

    .min-content {
      width: min-content;

      :where(td, th) & {
        width: 1%;
        white-space: nowrap;
      }
    }

    .text-center {
      text-align: center;
    }

    .nowrap {
      white-space: nowrap;
    }

    .support button,
    .support .btn,
    button.support,
    .support.btn {
      display: block;
      background: #3498DB;
      color: #FFF;
      padding: 8px 16px;
      border: 0;
      margin: 8px auto;
      cursor: pointer;
      text-decoration: none;
      font-size: 13px;

      &:hover {
        background: #266FA0;
      }

      &[disabled] {
        cursor: default;
        background: var(--neutral-4);
      }
    }

    .indicator {
      position: absolute;
      background: #C00;
      color: #FFF;
      font-size: 12px;
      height: 16px;
      width: 16px;
      text-align: center;
      border-radius: 50%;
      right: 0;
      bottom: 0;
      transform: translate(50%, 50%);
      display: flex;
      align-content: center;
      justify-content: center;
      flex-wrap: wrap;
    }
  `].flat();